import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DateFormat } from '../constants/date-format.constants';

@Pipe({
    name: 'lsqDate'
})
export class LsqDatePipe implements PipeTransform {
    constructor(private _datePipe: DatePipe, @Inject(LOCALE_ID) public locale: string) {}

    public transform(value: Date | string, dateFormat: string, useUtc: boolean = false): string {
        if (this.locale === 'en-US' && dateFormat === 'shortDate') {
            dateFormat = DateFormat.LsqShortYear;
        }
        if (typeof value === 'string' && value.indexOf('Z') > -1) {
            return this._datePipe.transform(
                value.substring(0, value.indexOf('Z')),
                dateFormat,
                useUtc ? 'UTC' : null
            );
        } else {
            return this._datePipe.transform(value, dateFormat, useUtc ? 'UTC' : null);
        }
    }
}
